import HttpStatus from 'http-status'
import moments from './moments'
import config from '../config'
import { isProd } from './common'

function RandomStr(length = 7) {
  let str = ''
  while (str.length < length)
    str += Math.random().toString(36).substr(2, 5)
  str = str.slice(0, length)
  return str
}

function DefaultErrorHandler(err) {
  if (err.status === 0) {
    this.$msgbox({
      title: '操作失败!',
      message: '无法连接到服务器，请确认网络情况。',
      type: 'error',
    })
  } else if (err.status === HttpStatus.UNAUTHORIZED) {
    if (isProd)
      this.$router.$go.login({ back: true })
    this.$message({
      type: 'warning',
      message: '登陆超时，请重新登陆。',
    })
  } else if (err.status === HttpStatus.FORBIDDEN) {
    this.$message({
      type: 'warning',
      message: '无权限进行此操作',
    })
  } else {
    const ce = this.$createElement
    this.$msgbox({
      title: '操作失败!',
      message: ce('div', { class: 'ui form' }, [
        ce('div', { class: 'ui field' }, [
          ce('label', null, `请求失败，代码：${err.status} (${HttpStatus[err.status]})`),
          ce('textarea', {
            attrs: {
              readonly: true,
            },
            domProps: {
              value: JSON.stringify(err, null, 2),
            },
          }, null),
        ]),
        ce('div', { class: 'ui field' }, [
          ce('label', null, '如果遇到问题，请向技术人员提供以上内容。'),
        ]),
      ]),
    })
  }
}

function DaysToExpire(contract) {
  if (contract) {
    const expire_date = moments(contract.date_expire || contract.date_start)
    const now = moments().utc().startOf('day')
    const days_to_expired = moments.daysBetween(expire_date, now)
    return days_to_expired
  }
  return Infinity
}

function ExpiringLevel(days_to_expire = 0) {
  const max = config.warning_color_levels.length
  let level = max
  let index = 0

  while (index <= max) {
    if (days_to_expire > config.warning_color_levels[index]) {
      level = index
      break
    } else
      ++index
  }
  return level
}

const utils = {
  RandomStr,
  DefaultErrorHandler,
  ExpiringLevel,
  DaysToExpire,
}

export * from './common'
export { default as moments } from './moments'
export { default as MakeForm } from './form'
export { default as MakeFetcher } from './fetcher'
export { utils }



// WEBPACK FOOTER //
// ./client/src/utils/index.js